// 曳引驱动杂物电梯检测项目数据
export const pageOneTreeData = [
  {
    id: 'A3.1.1',
    itemNumber: 'A3.1.1',
    description: '使用资料',
    level: 1,
    result: '',
    children: [
      {
        id: 'A3.1.1.1',
        itemNumber: 'A3.1.1.1',
        description: '使用资料',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.1.1.1-1',
            itemNumber: 'A3.1.1.1.1',
            description:
              '(1)使用单位应提供以下适用于受检电梯的资料：电气原理图、安装使用维护保养说明书、检验和检测报告；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.1.1.1-2',
            itemNumber: 'A3.1.1.1.2',
            description:
              '(2)使用单位应提供以下适用于受检电梯的资料：日常使用状况记录、维护保养记录、运行故障和事故记录。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A3.2.1',
    itemNumber: 'A3.2.1',
    description: '机器空间与井道',
    level: 1,
    result: '',
    children: [
      {
        id: 'A3.2.1.1',
        itemNumber: 'A3.2.1.1',
        description: '通往机器空间的通道',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.1.1-1',
            itemNumber: 'A3.2.1.1.1',
            description:
              '通道应保持通畅，相关人员能够安全、方便、无阻碍地使用，并且设有永久性电气照明。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.1.2',
        itemNumber: 'A3.2.1.2',
        description: '底坑',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.1.2-1',
            itemNumber: 'A3.2.1.2.1',
            description: '(1) 底坑地面平整，无渗水、积水；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.2.1.2-2',
            itemNumber: 'A3.2.1.2.2',
            description:
              '(2) 对于人员可进入的井道，底坑内应设有在进入底坑时以及在底坑地面上均能够方便操作的停止装置，并且功能有效。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.1.3',
        itemNumber: 'A3.2.1.3',
        description: '缓冲器或者限位挡块',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.1.3-1',
            itemNumber: 'A3.2.1.3.1',
            description:
              '(1) 缓冲器或者限位挡块无松动、明显倾斜、断裂、塑性变形、剥落、破损、严重锈蚀等现象；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.2.1.3-2',
            itemNumber: 'A3.2.1.3.2',
            description:
              '(2) 耗能型缓冲器液位正确，验证柱塞复位的电气安全装置功能有效；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.2.1.3-3',
            itemNumber: 'A3.2.1.3.3',
            description:
              '(3) 防爆杂物电梯的缓冲器与轿厢、对重(平衡重)的撞击面采取的无火花措施保持完好。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A3.2.2',
    itemNumber: 'A3.2.2',
    description: '电气设备和驱动主机',
    level: 1,
    result: '',
    children: [
      {
        id: 'A3.2.2.1',
        itemNumber: 'A3.2.2.1',
        description: '接地保护措施',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.2.1-1',
            itemNumber: 'A3.2.2.1.1',
            description:
              '(1)机器空间的电气设备及线管、线槽的外露可导电部分与保护导体(PE，地线)可靠连接；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.2.2.1-2',
            itemNumber: 'A3.2.2.1.2',
            description:
              '(2)含有电气安全装置的电路发生接地故障时，驱动主机应立即停止运转，或者在第一次正常停止运转后，能够防止驱动主机再启动。恢复杂物电梯运行只能通过手动复位。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.2.2',
        itemNumber: 'A3.2.2.2',
        description: '防爆电气部件',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.2.2-1',
            itemNumber: 'A3.2.2.2.1',
            description:
              '对于防爆杂物电梯，其防爆电气部件应符合本附件第A1.2.3.10条的要求。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.2.3',
        itemNumber: 'A3.2.2.3',
        description: '防爆电缆',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.2.3-1',
            itemNumber: 'A3.2.2.3.1',
            description:
              '对于防爆杂物电梯，其防爆电缆应符合本附件第A1.2.3.11条的要求。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.2.4',
        itemNumber: '*A3.2.2.4',
        description: '驱动主机',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.2.4-1',
            itemNumber: 'A3.2.2.4.1',
            description:
              '(1) 曳引轮绳槽、卷筒绳槽、链轮齿无缺损或者不正常磨损；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.2.2.4-2',
            itemNumber: 'A3.2.2.4.2',
            description: '(2) 制动器动作灵活、工作可靠；',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A3.2.3',
    itemNumber: 'A3.2.3',
    description: '悬挂装置',
    level: 1,
    result: '',
    children: [
      {
        id: 'A3.2.3.1',
        itemNumber: 'A3.2.3.1',
        description: '悬挂装置本体',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.3.1-1',
            itemNumber: 'A3.2.3.1.1',
            description:
              '(1)钢丝绳无笼状畸变、绳股挤出、扭结、部分压扁、弯折或者严重锈蚀等达到报废条件的现象；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.2.3.1-2',
            itemNumber: 'A3.2.3.1.2',
            description:
              '(2)链条无严重磨损、锈蚀、变形或者断裂等达到报废条件的现象；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.2.3.1-3',
            itemNumber: 'A3.2.3.1.3',
            description:
              '(3)其他类型悬挂装置的磨损、变形等不超过制造单位设定的报废指标。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.3.2',
        itemNumber: 'A3.2.3.2',
        description: '端接装置端部固定',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.3.2-1',
            itemNumber: 'A3.2.3.2.1',
            description:
              '(1)悬挂装置的端部固定部件无裂纹、松动等现象，端接装置的弹簧、螺母、开口销等连接部件无缺损；',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A3.2.4',
    itemNumber: 'A3.2.4',
    description: '轿厢与对重(平衡重)',
    level: 1,
    result: '',
    children: [
      {
        id: 'A3.2.4.1',
        itemNumber: 'A3.2.4.1',
        description: '轿厢位置指示信号',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.4.1-1',
            itemNumber: 'A3.2.4.1.1',
            description:
              '对于采用手动开启层门的杂物电梯，应设有表示轿厢在此层站的信号，并符合以下要求：(1)轿厢停留在该层站期间保持开启；(2)轿厢离开该层站后自动关闭；(3)醒目并且不被遮挡。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.4.2',
        itemNumber: '*A3.2.4.2',
        description: '防止轿厢移动装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.4.2-1',
            itemNumber: 'A3.2.4.2.1',
            description:
              '对于允许人员进入轿顶的杂物电梯，应符合以下要求：①轿厢设置机械停止装置以使其停在指定位置上；②在轿顶上或者井道内每一层门旁设有停止装置。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.4.3',
        itemNumber: 'A3.2.4.3',
        description: '轿厢入口',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.4.3-1',
            itemNumber: 'A3.2.4.3.1',
            description:
              '轿厢入口处设有挡板、栅栏、卷帘、轿门时，应符合以下要求：① 验证其关闭状态的电气安全装置功能有效；②运行时无脱轨、机械卡阻或者错位现象。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.4.4',
        itemNumber: 'A3.2.4.4',
        description: '对重(平衡重)块',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.4.4-1',
            itemNumber: 'A3.2.4.4.1',
            description: '对重(平衡重)块无松动、移位等现象。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A3.2.5',
    itemNumber: 'A3.2.5',
    description: '层门与轿门',
    level: 1,
    result: '',
    children: [
      {
        id: 'A3.2.5.1',
        itemNumber: 'A3.2.5.1',
        description: '门间隙',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.5.1-1',
            itemNumber: 'A3.2.5.1.1',
            description:
              '门关闭后，测量门扇之间及门扇与立柱、门楣和地坎之间的间隙应不大于6mm。使用过程中由于磨损，允许达到10mm。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table1'
          }
        ]
      },
      {
        id: 'A3.2.5.2',
        itemNumber: '*A3.2.5.2',
        description: '门再开启保护装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.5.2-1',
            itemNumber: 'A3.2.5.2.1',
            description:
              '在自动门关闭过程中，人员或者货物被撞击或者将被撞击时，保护装置应能够自动使门重新开启。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.5.3',
        itemNumber: '*A3.2.5.3',
        description: '门的运行与导向',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.5.3-1',
            itemNumber: 'A3.2.5.3.1',
            description: '层门正常运行时，应无脱轨、机械卡阻或者错位现象。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.5.4',
        itemNumber: '*A3.2.5.4',
        description: '自动关闭层门装置',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.5.4-1',
            itemNumber: 'A3.2.5.4.1',
            description:
              '(1)在轿门驱动层门的情况下，当轿厢在开锁区域之外时，自动关闭层门装置应能够使开启的层门关闭。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table2'
          },
          {
            id: 'A3.2.5.4-2',
            itemNumber: 'A3.2.5.4.2',
            description:
              '(2)自动关闭层门装置采用重块的，其防止重块坠落的措施应保持有效；对于防爆杂物电梯，无火花措施应保持完好。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.5.5',
        itemNumber: 'A3.2.5.5',
        description: '紧急开锁',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.5.5-1',
            itemNumber: 'A3.2.5.5.1',
            description:
              '每个层门均应能够被专用钥匙从外面开启；紧急开锁后，在层门闭合时门锁装置应未保持在开锁位置。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table3'
          },
          {
            id: 'A3.2.5.5-2',
            itemNumber: 'A3.2.5.5.2',
            description:
              '对于允许按照JG 135—2000《杂物电梯》及更早期标准生产的杂物电梯，可以仅在端站层门配置紧急开锁装置。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.5.6',
        itemNumber: '*A3.2.5.6',
        description: '门的锁紧与闭合',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.5.6-1',
            itemNumber: 'A3.2.5.6.1',
            description:
              '(1) 每个层门均设有门锁装置，其锁紧动作由重力、永久磁铁或者弹簧来产生和保持，即使永久磁铁或者弹簧失效，重力也不能导致开锁；',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table4'
          },
          {
            id: 'A3.2.5.6-2',
            itemNumber: 'A3.2.5.6.2',
            description:
              '(2) 门的锁紧由电气安全装置电气证实，只有在层门锁紧后杂物电梯才能运行。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table5'
          },
          {
            id: 'A3.2.5.6-3',
            itemNumber: 'A3.2.5.6.3',
            description:
              '对于同时满足额定速度不大于0.63m/s、开门高度不大于1.20m和层站地坎距地面高度不小于0.70m的杂物电梯，门的锁紧可以不由电气装置电气证实，但当轿厢驶离开锁区域时，锁紧元件能够自动关闭，而且除了正常锁紧位置外，至少有第二个锁紧位置；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.2.5.6-4',
            itemNumber: 'A3.2.5.6.4',
            description:
              '(3) 每个层门的闭合均由电气安全装置来验证，如果滑动门是由数个间接机械连接的门扇组成，则未被锁住的门扇上也设有电气安全装置以验证其闭合状态。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A3.2.5.7',
        itemNumber: '*A3.2.5.7',
        description: '层站标识',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.2.5.7-1',
            itemNumber: 'A3.2.5.7.1',
            description:
              '每个层门或者其附近位置应标示杂物电梯的额定载重量，并且设有包含"禁止进入轿厢"字样的警示标志。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table6'
          }
        ]
      }
    ]
  },
  {
    id: 'A3.3.1',
    itemNumber: '*A3.3.1',
    description: '轿厢限速器-安全钳试验',
    level: 1,
    result: '',
    children: [
      {
        id: 'A3.3.1.1',
        itemNumber: 'A3.3.1.1',
        description: '轿厢限速器-安全钳试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.3.1.1-1',
            itemNumber: 'A3.3.1.1.1',
            description:
              '(1)限速器各调节部位封记完好，运转时无碰擦、卡阻、转动不灵活等现象，动作正常；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.3.1.1-2',
            itemNumber: 'A3.3.1.1.2',
            description:
              '(2)当限速器绳或者安全绳断裂或者过分伸长时，应能够通过电气安全装置防止杂物电梯的正常运行；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.3.1.1-3',
            itemNumber: 'A3.3.1.1.3',
            description:
              '(3)轿厢上设置的在轿厢安全钳动作以前或者同时使驱动主机停止运转的电气安全装置功能应有效；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.3.1.1-4',
            itemNumber: 'A3.3.1.1.4',
            description:
              '(4) 轿厢空载、以额定速度或者检修速度下行，进行限速器-安全钳联动试验；对于采用悬挂装置断裂或者安全绳触发的轿厢安全钳，轿厢空载，模拟悬挂装置断裂或者安全绳被触发的状态进行试验，限速器、安全钳动作应可靠。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A3.3.2',
    itemNumber: '*A3.3.2',
    description: '对重(平衡重)限速器-安全钳试验',
    level: 1,
    result: '',
    children: [
      {
        id: 'A3.3.2.1',
        itemNumber: 'A3.3.2.1',
        description: '对重(平衡重)限速器-安全钳试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.3.2.1-1',
            itemNumber: 'A3.3.2.1.1',
            description:
              '(1)限速器各调节部位封记应完好，运转时无碰擦、卡阻、转动不灵活等现象，动作应正常。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.3.2.1-2',
            itemNumber: 'A3.3.2.1.2',
            description:
              '(2)当限速器绳或者安全绳断裂或者过分伸长时，应能够通过电气安全装置防止杂物电梯的正常运行；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A3.3.2.1-3',
            itemNumber: 'A3.3.2.1.3',
            description:
              '(3)轿厢空载，以额定速度或者检修速度上行，进行限速器-安全钳联动试验；对于采用悬挂装置断裂或者安全绳触发的安全钳，轿厢空载，模拟悬挂装置断裂或者安全绳被触发的状态进行试验，限速器安全钳动作应可靠。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A3.3.5',
    itemNumber: '*A3.3.5',
    description: '上行制动试验',
    level: 1,
    result: '',
    children: [
      {
        id: 'A3.3.5.1',
        itemNumber: 'A3.3.5.1',
        description: '上行制动试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.3.5.1-1',
            itemNumber: 'A3.3.5.1.1',
            description:
              '对于曳引式杂物电梯，轿厢空载以额定速度上行至行程上部，切断电动机与制动器供电，轿厢应当能够完全停止。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  {
    id: 'A3.3.6',
    itemNumber: 'A3.3.6',
    description: '运行试验',
    level: 1,
    result: '',
    children: [
      {
        id: 'A3.3.6.1',
        itemNumber: 'A3.3.6.1',
        description: '运行试验',
        level: 2,
        result: '',
        children: [
          {
            id: 'A3.3.6.1-1',
            itemNumber: 'A3.3.6.1.1',
            description:
              '轿厢空载，以额定速度上、下运行，呼梯、楼层显示等信号系统应功能有效、指示正确、动作无误，无异常现象发生。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table7'
          }
        ]
      }
    ]
  }
]

function initLeafDialogOpenFlag (nodes) {
  if (!Array.isArray(nodes)) return
  nodes.forEach(item => {
    if (!item || typeof item !== 'object') return
    const hasChildren = Array.isArray(item.children) && item.children.length > 0
    if (!hasChildren) {
      item.hasOpenedResultDialog = false
      return
    }
    initLeafDialogOpenFlag(item.children)
  })
}

initLeafDialogOpenFlag(pageOneTreeData)
